export enum TechLookupProductType {
  CABLE = 'Cable',
  DATA = 'Data',
  CABLE_AND_DATA = 'CableData',
}

export enum TechLookupOrderType {
  INSTALL = 'IN',
  UPGRADE = 'UP',
}

export enum TechLookupTechType {
  SKY = 'Sky',
  CHORUS = 'Chorus',
}

export interface TechnicianSlot {
  code: string;
  startTime: Date;
  endTime: Date;
  displayName: string;
}
export interface TechnicianDateSlots {
  date: Date;
  slots: TechnicianSlot[];
}
export const InstallationTimeCodes = {
  AM: '8am - 12pm',
  AM1: '8am - 9am',
  AM2: '9am - 12pm',
  PM: '12pm - 6pm',
  PM1: '12pm - 4pm',
  PM2: '4pm - 6pm',
  ALLDAY: '8am - 6pm',
} as const;

export const New_InstallationTimeCodes = {
  AM2: '8am - 12pm',
  PM1: '12pm - 5pm',
  ALLDAY: '8am - 5pm',
} as const;

export const InstallationTimeCodeKeys = {
  AM: 'AM',
  AM1: 'AM1',
  AM2: 'AM2',
  PM: 'PM',
  PM1: 'PM1',
  PM2: 'PM2',
  ALLDAY: 'ALLDAY',
};

export const InstallationTimeCodesHalfDay = {
  AM: '8am - 12pm',
  PM: '12pm - 6pm',
} as const;
export type NullableDate = null | Date;

export const SPLITIO_KEY = {
  SKYWEB_TRACKER_RESCHEDULE: 'SKYWEB_TRACKER_RESCHEDULE',
  SKYWEB_TECHNICIAN_LOOKUP: 'SKYWEB_TECHNICIAN_LOOKUP',
  MAINTENANCE_MODE_NBJ: 'MAINTENANCE_MODE_NBJ',
  SKYWEB_ENABLE_QUALTRICS: 'SKYWEB_ENABLE_QUALTRICS',
  SKY_WEB_SALESFORCE_CHAT_CART: 'SKY_WEB_SALESFORCE_CHAT_CART',
  SKY_WEB_SALESFORCE_NEW_CHAT_SALES: 'SKY_WEB_SALESFORCE_NEW_CHAT_SALES',
  SKY_WEB_SALESFORCE_NEW_CHAT_LIVE: 'SKY_WEB_SALESFORCE_NEW_CHAT_LIVE',
  SKY_WEB_SPORT_COMMS: 'SKY_WEB_SPORT_COMMS',
  SKY_WEB_PRICE_INCREASE_COMMS: 'SKY_WEB_PRICE_INCREASE_COMMS',
  SKYWEB_NBJ_VOUCHER_ENABLE: 'SKYWEB_NBJ_VOUCHER_ENABLE',
  ABADANCART_UI_FLOW: 'AbadanCart_UI_Flow',
};
